import React, {Component} from "react"
import qs from "qs"

import id from "@irati/utils/id"
import {getQuery} from "@irati/utils/history"
import Form from "@irati/ui/src/Form"
import Input from "@irati/ui/src/FormItem/Input"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import Loading from "@irati/ui/src/Loading"
import Validation from "@irati/utils/validation"
import {InjectIntl, injectIntl, FormattedMessage} from "@irati/utils/lang"
import session from "@irati/auth/services/session"
import {hangPromise} from "@irati/utils/promise"
import Link, {RouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import {getGlobalTenant} from "@irati/region/services/globalTenant"
import {H5, Body, Label, H3} from "@irati/ui/src/Typography"
import tracking from "@irati-tracking/platform/platform"
import {setLoginProduct} from "@irati-tracking/tracker/trackers/mixpanel/platform"

import LoginBlock from "../../../components/LoginBlock"
import {ToastError} from "./ToastMessage"
import {InputHolder} from "./styled"

interface Props extends InjectIntl {}

interface State {
  submit: Promise<any> | null
  subdomain: string
  invalidTenant?: string
}

interface QueryParams {
  redirectTo?: string
}

class GlobalLogin extends Component<Props, State> {
  state: State = {
    subdomain: localStorage.getItem("companyDomain") || "",
    submit: null
  }

  componentDidMount() {
    setLoginProduct("password_login")

    const invalidTenant = getQuery().invalidTenant
    if (invalidTenant) {
      this.setState({invalidTenant})
    }
  }

  handleSubmit = () => {
    const subdomain = this.state.subdomain.trim()
    const submit = getGlobalTenant(subdomain).then(() => {
      const query = qs.parse(window.location.search.replace("?", "")) as QueryParams
      localStorage.setItem("companyDomain", subdomain)
      tracking.submitDomain()
      return session.postCrossDomain(subdomain, {}, {pathname: query.redirectTo ?? "/welcome/login/password"}).then(hangPromise)
    })

    this.setState({submit})
  }

  updateSubdomain = (subdomain: string) => {
    this.setState({subdomain, submit: null})
  }

  hideError = () => {
    this.setState({invalidTenant: undefined})
  }

  render() {
    const {submit, invalidTenant} = this.state
    const {formatMessage} = this.props
    const idNamespace = id("global-login", this.props)

    const helpLinks = [
      <Link href={formatMessage({id: "platform.globalLogin.subdomain.help.whatIsDomain.url"})} target="_blank">
        <FormattedMessage id="platform.globalLogin.subdomain.help.whatIsDomain.text" />
      </Link>,
      <FormattedMessage
        id="platform.globalLogin.subdomain.help.body"
        values={{
          link: (
            <RouterLink to="/welcome/login/domain">
              <FormattedMessage id="platform.globalLogin.subdomain.help.link.text" />
            </RouterLink>
          )
        }}
      />,
      <RouterLink to="/welcome/login">
        <FormattedMessage id="platform.globalLogin.subdomain.help.otp.text" />
      </RouterLink>
    ]
    return (
      <>
        {invalidTenant && (
          <ToastError onClose={this.hideError}>
            <H5 marginBottom={0.5}>
              <FormattedMessage id="platform.globalLogin.message.invalidTenantHeader" />
            </H5>
            <Body>
              <FormattedMessage
                id="platform.globalLogin.message.invalidTenantBody"
                values={{
                  tenant: invalidTenant
                }}
              />
            </Body>
          </ToastError>
        )}
        <LoginBlock id={idNamespace} helpLinks={helpLinks} hideTitle>
          <H3 id={id("title", idNamespace)} textAlign="center">
            <FormattedMessage id="platform.globalLogin.fields.welcomeTo.title" />
          </H3>
          <div className="globalLogin_wrapper">
            <Body small id={id("card-title", idNamespace)} padding={[2, 0, 2, 0]} textAlign="center" maxWidth="100%">
              <FormattedMessage id="platform.globalLogin.fields.signIn.subdomainTitle" />
            </Body>
            <Form form="global-login">
              <Flex justifyContent="space-between" alignItems="center">
                <InputHolder>
                  <Input
                    id={id("subdomain", idNamespace)}
                    flush
                    label={formatMessage({id: "platform.globalLogin.fields.subdomain.label"})}
                    name="subdomain"
                    type="text"
                    value={this.state.subdomain}
                    placeholder={formatMessage({id: "platform.globalLogin.fields.subdomain.placeholder"})}
                    onChange={this.updateSubdomain}
                    onEnter={() =>
                      Validation.validate()
                        .then(this.handleSubmit)
                        .catch(() => {})
                    }
                    validation={Validation.string("platform.globallogin.domain.errors.isrequired")}
                    autoFocus
                  />
                </InputHolder>
                <Flex marginLeft paddingTop={2}>
                  <Label>.perkbox.com</Label>
                </Flex>
              </Flex>
              <Loading id={id("submit-response", idNamespace)} load={submit} useLoader={false} />
              <ValidationButton id={id("btn-submit", idNamespace)} primary full marginTop={3} load={submit} onClick={this.handleSubmit}>
                <FormattedMessage id="platform.globalLogin.fields.button.continue" />
              </ValidationButton>
            </Form>
          </div>
        </LoginBlock>
      </>
    )
  }
}

export default injectIntl(GlobalLogin)
